import { Box, Typography } from "@mui/material";
import { VeiculoInfoCard } from "./VeiculoInfoCard";



import { ReactNode } from "react";
import { AnunciosShopkeeper } from "../dto/ShopkeeperDTO";
import { getStatusBgColor, getStatusLabel } from "../helpers/Helpers";
import { AnuncioCard } from "./AnuncioCard";
import { AnuncioDetalhesVeiculos } from "./AnuncioDetalhesVeiculos";
import { AnuncioFooter } from "./AnuncioFooter";
import { AnuncioImagens } from "./AnuncioImagens";

export interface VeiculoInfoItemDTO {
  icon: ReactNode;
  label: string;
}

export interface VeiculoDTO {
  titulo: string;
  itens: VeiculoInfoItemDTO[];
}

export type AnuncioStatus = "N" | "L" | "C" | "P";

export interface AnuncioItemDTO {
  imagens: string[];
  status: AnuncioStatus;
  titulo: string;
  id_anuncio: number;
  veiculos: VeiculoDTO[];
  anuncio: AnunciosShopkeeper;
  footer: {
    actionLabel: string;
    onAction: () => void;
    id_concessionaria: number;
    logo: string;
    cidade: string;
    uf: string;
    melhorOferta: string;
    compreAgora: string;
    tipoAnuncio: string;
  };
  highlighted?: boolean;
  open: boolean;
  onToggle: () => void;
}



export function AnuncioItemCard({
  imagens,
  status,
  titulo,
  veiculos,
  footer,
  highlighted = false,
  open,
  onToggle,
  anuncio
}: AnuncioItemDTO) {
  return (
    <AnuncioCard highlighted={highlighted}>
      {/* IMAGENS */}
      <AnuncioImagens imagens={imagens}/>

      {/* CONTEÚDO */}
      <Box p={2} flex="1" display="flex" flexDirection="column">
        {/* STATUS */}
        <Box
          display="inline-flex"
          alignItems="center"
          px={1.5}
          py={0.5}
          borderRadius={1}
          bgcolor={getStatusBgColor(status)}
          alignSelf="flex-start"
        >
          <Typography
            fontSize="0.85rem"
            color="white"
            fontWeight={800}
            fontStyle="italic"
            textTransform="uppercase"
          >
            {getStatusLabel(status)}
          </Typography>
        </Box>

        {/* TÍTULO */}
        <Typography 
          fontSize="1.1rem" 
          fontWeight={800} 
          mt={2}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            minHeight: "52px",
            lineHeight: "26px"
          }}
        >
          {titulo}
        </Typography>

        {/* DETALHES */}
        <Box flex="1">
          {veiculos.length > 0 && (
            <AnuncioDetalhesVeiculos
            open={open}
            key={`detalhes-${titulo}`}
            onToggle={onToggle}
            >
              {veiculos.map((veiculo, index) => (
                <VeiculoInfoCard
                  key={index}
                  titulo={veiculo.titulo}
                  itens={veiculo.itens}

                />
              ))}
            </AnuncioDetalhesVeiculos>
          )}
        </Box>
      </Box>

      {/* FOOTER */}
      <AnuncioFooter
        label={getStatusLabel(status)}
        melhorOferta={footer.melhorOferta}
        compreAgora={footer.compreAgora}
        tipoAnuncio={footer.tipoAnuncio}
        actionLabel={footer.actionLabel}
        onAction={footer.onAction}
        id_concessionaria={footer.id_concessionaria}
        logo={footer.logo}
        cidade={footer.cidade}
        uf={footer.uf}
        anuncio={anuncio}
      />
    </AnuncioCard>
  );
}
